import { Button, Col, DatePicker, DatePickerProps, Form, Input, InputNumber, Row, Table, Tag, Select } from 'antd';
import Column from 'antd/es/table/Column';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Links } from '../../helpers/Links';
import { dateCommon, formatVND, validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { khoiTaoLuongBoSungTruongBKS, timKiemDsLuongBoSungTruongBKS, layDsLuongCoBanChoLuongBSTBKS, layDsLuongBoSungTruongBKSTheoNam } from '../../services/luong';
import SelectThamChieuLuongCoBanBSTBKS from '../../modules/salary/SelectThamChieuLuongCoBanBSTBKS';
import { LuongBoSungTruongBKSInfo } from '../../models/luong/LuongBoSungTruongBKS';


const generateMonths = () => {
    const months = [];
    const now = dayjs();
    const startDate = now.subtract(3, 'year').startOf('year');
    const endDate = now.add(1, 'year').endOf('year');
    
    let current = startDate;
    while (current.isBefore(endDate) || current.isSame(endDate)) {
        months.push(current.format('YYYY'));
        current = current.add(1, 'year');
    }
    return Array.from(new Set(months)).map(year => ({ label: `Năm ${year}`, value: Number(year) }));
};


const DanhSachLuongBoSungTruongBKS = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const loaiWatch = Form.useWatch('loai', form);
    const namWatch = Form.useWatch('nam', form);
    
    const [dsLuongCoBan, setDsLuongCoBan] = useState<any[]>([]);
    const [dsLuongBoSung, setDsLuongBoSung] = useState<any[]>([]);
    const [namLocLuongCoBan, setNamLocLuongCoBan] = useState<Dayjs | null>(null);
    const [namLocLuongBoSung, setNamLocLuongBoSung] = useState<Dayjs | null>(null);

    const layDsLuongCoBanModal = async (nam?: number) => {
        try {
            const rs = await layDsLuongCoBanChoLuongBSTBKS(nam);
            setDsLuongCoBan(rs ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    const layDsLuongBoSungModal = async (nam?: number) => {
        try {
            const rs = await layDsLuongBoSungTruongBKSTheoNam(nam);
            setDsLuongBoSung(rs ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    const onChangeNamLocLuongCoBan = async (date: Dayjs | null) => {
        setNamLocLuongCoBan(date);
        form.setFieldsValue({ idsLuongCoBan: [] });
        await layDsLuongCoBanModal(date ? date.year() : undefined);
    };

    const onChangeNamLocLuongBoSung = async (date: Dayjs | null) => {
        setNamLocLuongBoSung(date);
        form.setFieldsValue({ idsLuongBoSung: [] });
        await layDsLuongBoSungModal(date ? date.year() : undefined);
    };



    const [loading, setLoading] = useState(false);
    const [dataDs, setDataDs] = useState<LuongBoSungTruongBKSInfo[]>([]);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(null);
    const [openModalKhoiTao, setOpenModalKhoiTao] = useState(false);

    const layDuLieu = async (thangNam?: string) => {
        setLoading(true);
        try {
            const rs = await timKiemDsLuongBoSungTruongBKS(0, 1000, thangNam);
            setDataDs(rs?.data ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        setLoading(false);
    };

    useEffect(() => {
        layDuLieu(ngayThang ? ngayThang.format('MM/YYYY') : undefined);
    }, []);

    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;

    const onChangeThangNam: DatePickerProps['onChange'] = (date) => {
        setNgayThang(date);
        layDuLieu(date ? date.format('MM/YYYY') : undefined);
    };

    
    const onMoModalKhoiTao = async () => {
        const ky = ngayThang ?? dayjs();
        const namKy = dayjs().year(ky.year());
        setNamLocLuongCoBan(namKy);
        setNamLocLuongBoSung(namKy);

        form.setFieldsValue({
            kyLuong: ky,
            quyLuong: undefined,
            loai: 0,
            nam: ky.year(),
            idsLuongCoBan: [],
            idsLuongBoSung: [],
            tenKyLuong: undefined,
            tyLeTamUng: 100,
            soThangLamViec: undefined
        });

        await Promise.all([
            layDsLuongCoBanModal(ky.year()),
            layDsLuongBoSungModal(ky.year())
        ]);

        setOpenModalKhoiTao(true);
    }


    
    const onFinishKhoiTao = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            const ky = values?.kyLuong as Dayjs;
            const request = {
                thangNam: ky ? ky.format('MM/YYYY') : null,
                quyLuong: Number(values?.quyLuong ?? 0),
                loai: values?.loai ?? 0,
                nam: values?.nam,
                tenKyLuong: values?.tenKyLuong,
                tyLeTamUng: values?.loai === 2 ? 100 : (values?.tyLeTamUng ?? 100),
                soThangLamViec: values?.soThangLamViec,
                idsLuongCoBan: (values?.idsLuongCoBan ?? []).join(','),
                idsLuongBoSung: (values?.idsLuongBoSung ?? []).join(',')
            };
            const rs = await khoiTaoLuongBoSungTruongBKS(request);

            if (rs > 0) {
                toast.success('Khởi tạo lương bổ sung Trưởng BKS thành công!');
                setOpenModalKhoiTao(false);
                layDuLieu(ngayThang ? ngayThang.format('MM/YYYY') : undefined);
            } else {
                toast.error('Khởi tạo lương bổ sung Trưởng BKS thất bại!');
            }
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    return (
        <section>
            {openModalKhoiTao && (
                <ModalTextForm
                    title="Khởi tạo lương bổ sung Trưởng BKS"
                    hideFooter
                    show={openModalKhoiTao}
                    handleClose={() => setOpenModalKhoiTao(false)}
                >
                    
                    <Form
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinishKhoiTao}
                        form={form}
                    >
                        <Row gutter={8}>
                            <Col span={12}>
                                <Form.Item rules={[{ required: true }]} label="Loại" name="loai">
                                    <Select
                                        options={[
                                            { value: 0, label: "Lương bổ sung/Tháng" },
                                            { value: 1, label: "Điều chỉnh" },
                                            { value: 2, label: "Quyết toán" },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>
                            {loaiWatch !== 1 && loaiWatch !== 2 ? (
                                <Col span={12}>
                                    <Form.Item rules={[{ required: true }]} label="Tháng năm" name="kyLuong">
                                        <DatePicker
                                            changeOnBlur={true}
                                            picker="month"
                                            format={["MM/YYYY", "MMYYYY"]}
                                            placeholder="Chọn kỳ lương"
                                            style={{ width: '100%' }}
                                        />
                                    </Form.Item>
                                </Col>
                            ) : (
                                <Col span={12}>
                                    <Form.Item rules={[{ required: true }]} label="Năm" name="nam">
                                        <Select options={generateMonths()} />
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>
                        {(loaiWatch === 1 || loaiWatch === 2) && (
                            <Row gutter={8}>
                                <Col span={24}>
                                    <Form.Item label="Tên kỳ lương bổ sung" name="tenKyLuong" rules={[{ required: true, message: 'Vui lòng nhập tên kỳ lương bổ sung' }]}>
                                        <Input placeholder="Nhập tên kỳ lương bổ sung..." />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        {(loaiWatch === 1 || loaiWatch === 2) && (
                            <Row gutter={8}>
                                <Col span={loaiWatch === 1 ? 12 : 24}>
                                    <Form.Item label="Số tháng làm việc" name="soThangLamViec" rules={[{ required: true, message: 'Vui lòng nhập số tháng' }]}>
                                        <InputNumber min={0} max={12} step={0.5} style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>
                                {loaiWatch === 1 && (
                                    <Col span={12}>
                                        <Form.Item label="Tỷ lệ tạm ứng (%)" name="tyLeTamUng" rules={[{ required: true, message: 'Vui lòng nhập tỷ lệ' }]}>
                                            <InputNumber min={0} max={100} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col span={24}>
                                <Form.Item rules={[{ required: true }]} label={loaiWatch === 1 ? "Mức tiền lương/tháng kế hoạch được duyệt" : loaiWatch === 2 ? "Mức tiền lương thực hiện/tháng" : "Quỹ tiền lương KH/tháng được tạm ứng "} name="quyLuong">
                                    <InputNumber
                                        min={0}
                                        precision={0}
                                        placeholder="Nhập quỹ lương"
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        {(loaiWatch === 1 || loaiWatch === 2) && (
                            <>
                                <Row gutter={8}>
                                    <Col span={8}>
                                        <Form.Item label="Năm lương cơ bản">
                                            <DatePicker
                                                changeOnBlur={true}
                                                picker="year"
                                                placeholder="Năm (để trống = tất cả)"
                                                style={{ width: "100%" }}
                                                value={namLocLuongCoBan}
                                                onChange={onChangeNamLocLuongCoBan}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label="Tham chiếu Lương cơ bản" name="idsLuongCoBan">
                                            <SelectThamChieuLuongCoBanBSTBKS
                                                dataSource={dsLuongCoBan}
                                                placeholder="Chọn kỳ lương cơ bản"
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={8}>
                                        <Form.Item label="Năm lương bổ sung">
                                            <DatePicker
                                                changeOnBlur={true}
                                                picker="year"
                                                placeholder="Năm (để trống = tất cả)"
                                                style={{ width: "100%" }}
                                                value={namLocLuongBoSung}
                                                onChange={onChangeNamLocLuongBoSung}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label="Tham chiếu Lương bổ sung" name="idsLuongBoSung">
                                            <Select
                                                mode="multiple"
                                                placeholder="Chọn kỳ lương bổ sung"
                                                options={dsLuongBoSung.map((x: any) => ({ label: x.tenKyLuong, value: x.id.toString() }))}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
<Form.Item>
                            <Button
                                type="primary"
                                className="float-right"
                                htmlType="submit"
                                icon={<SaveOutlined />}
                            >
                                Khởi tạo
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}

            <ContentHeader title="Lương bổ sung Trưởng BKS" />

            <Row className="form-group" gutter={8}>
                <Col span={6}>
                    <DatePicker
                        changeOnBlur={true}
                        value={ngayThang}
                        onChange={onChangeThangNam}
                        placeholder="Tháng tính lương"
                        picker="month"
                        format={thangNamFormat}
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col span={18}>
                    <Button
                        className="hrm-btn hrm-btn-warning float-right"
                        icon={<PlusOutlined />}
                        onClick={onMoModalKhoiTao}
                    >
                        Khởi tạo lương bổ sung Trưởng BKS
                    </Button>
                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={24}>
                    <div className="card card-primary">
                        <Row>
                            <Col span={24}>
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={(dataDs || []).map((value, index) => ({ key: index, ...value }))}
                                    loading={loading}
                                >
                                    <Column
                                        title="STT"
                                        width={60}
                                        align="center"
                                        render={(_v, _r, index) => (
                                            <div className="text-align-middle">{index + 1}</div>
                                        )}
                                    />
                                    <Column
                                        title="Kỳ lương"
                                        key="tenKyLuong"
                                        align="left"
                                        render={(value: any) => (
                                            <div className="text-align-middle">{value?.tenKyLuong}</div>
                                        )}
                                    />
                                    <Column
                                        title="Mức lương/tháng"
                                        key="quyLuong"
                                        align="center"
                                        render={(value: any) => (
                                            <div className="text-align-middle">
                                                {[1, 2].includes(value.loai) ? formatVND(Math.round(value?.quyLuong * value.tyLeTamUng / 100)) : formatVND(value?.quyLuong ?? 0)}
                                            </div>
                                        )}
                                    />
                                    <Column
                                        title="Loại"
                                        key="loai"
                                        align="center"
                                        render={(value: any) => (
                                            value.loai === 2 ? (
                                                <Tag color="purple">Quyết toán</Tag>
                                            ) : value.loai === 1 ? (
                                                <Tag color="orange">Điều chỉnh</Tag>
                                            ) : (
                                                <Tag color="default">LBS/Tháng</Tag>
                                            )
                                        )}
                                    />
                                    <Column
                                        title="Trạng thái"
                                        key="trangThai"
                                        align="center"
                                        render={(value: any) => (
                                            value.trangThai == 0 ? (<Tag color="blue">Khởi tạo</Tag>) : (<Tag color="success">Đã xác nhận</Tag>)
                                        )}
                                    />
                                    <Column
                                        title="Người khởi tạo"
                                        key="tenNVKhoiTao"
                                        align="center"
                                        render={(value) => (
                                            <div className="text-align-middle">{value?.tenNVKhoiTao}</div>
                                        )}
                                    />
                                    <Column
                                        title="Ngày khởi tạo"
                                        key="ngayKhoiTao"
                                        align="center"
                                        render={(value) => (
                                            <div className="text-align-middle">{dateCommon.formatDate(value?.ngayKhoiTao)}</div>
                                        )}
                                    />
                                    <Column
                                        title=""
                                        width={120}
                                        key="action"
                                        align="center"
                                        render={(value: any, _record, index) => (
                                            <Link
                                                key={"link" + index}
                                                className="hrm-btn hrm-btn-sm btn-primary"
                                                to={`${Links.Luong.ChiTietLuongBoSungTruongBKS}?id=${value?.id}`}
                                            >
                                                Xem
                                            </Link>
                                        )}
                                    />
                                </Table>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachLuongBoSungTruongBKS;